/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports

import { createStore } from "vuex";

// Store functionality
import actions from "./actions";
import getters from "./getters";
import user from "./modules/user";
import mutations from "./mutations";
import state from "./state";
import accounts from "./modules/accounts";
import settings from "./modules/settings";
import ticket from "./modules/ticket";
import transaction from "./modules/transaction";
import businessaccount from "./modules/businesaccounts";
// Create a new store
const store = createStore({
  modules: {
    user,
    accounts,
    settings,
    ticket,
    businessaccount,
    transaction,
  },
  actions,
  getters,

  mutations,
  state,
});

export default store;
